import axios from "axios"
import UnAuthorizedComponent from "common/UnAuthorizedComponent"
import EditProjectData from "pages/Projects/EditProjectData/EditProjectData"
import { convertPermission } from "permissionUtils"
import React, { useEffect, useState } from "react"
import { useHistory } from "react-router-dom"
import { Button, Col, Row } from "reactstrap"
import NewTicketModal from "./NewTicketModal"

const ProjectHeader = ({ projectID,from }) => {
  const history = useHistory()
  const [project, setProject] = useState()
  const [editing, setEditing] = useState(false)
  const [editModal, setEditModal] = useState(false)

  const editToggle = () => {
    setEditModal(!editModal)
  }

  // **************** Permissions ******************************
  const userPermissions = convertPermission(
    JSON.parse(localStorage.getItem("roles"))
  )
  // console.log("userPermissions", userPermissions)

  // **************** Authorization ******************************
  const [auth, setAuth] = useState(false)

  useEffect(() => {
    const formData = {
      PerToken: localStorage.getItem("token"),
      PerUserID: localStorage.getItem("id"),
      PerRoleID: localStorage.getItem("userRoleID"),
      ProjectID: projectID,
    }
    axios
      .post(process.env.REACT_APP_API_URL+"api/ProjectsView", formData)
      .then(res => {
        if (res.data.error === true && res.data.message === "Access denied!") {
          setAuth(true)
          setTimeout(() => {
            history.push("/logout")
            setTimeout(() => {
              history.push("/login")
            }, 1000)
          }, 4000)
        }

        // console.log("res", Object.entries(res.data)[0][1])
        setProject(Object.entries(res.data)[0][1])
      })
      .catch(err => console.log(err))
  }, [editing])



  // add newticket
  const [addNewticket,setAddNewticket] = useState(false)
  const addNewticketToggle = () => {
    setAddNewticket(!addNewticket)
  }

  // Access denied !!
  if (auth) {
    return <UnAuthorizedComponent />
  }

  return (
    <div className="pb-4 px-4">
      <Row>
        <Col sm={4} className=" my-2">
          <h5>
            <span style={{ fontWeight: "700" }}>Reference No : </span>
            {project?.ReferenceNo}
          </h5>
        </Col>
        <Col sm={4} className="my-2">
          <h5>
            <span style={{ fontWeight: "700" }}>Region : </span>
            {project?.CityNameEN}
          </h5>
        </Col>
        <Col sm={4} className="my-2">
          <h5>
            <span style={{ fontWeight: "700" }}>Soil Reports : </span>
            {project?.Soil || "not found"}
          </h5>
        </Col>
        <Col sm={7} className="my-2">
          <h5>
            <span style={{ fontWeight: "700" }}>Project Total Cost : </span>
            SAR {project?.Cost}
          </h5>
        </Col>
       {/* {from&& <Col  sm={2} className="my-2 d-flex justify-content-center">
          <Button
            color="primary"
            onClick={() => addNewticketToggle()}
            disabled={
              userPermissions.R7.P !== "3" && userPermissions.R7.P !== "4"
            }
          >
            Add New Ticket
          </Button>
        </Col>} */}
        <Col sm={2} className="my-2 d-flex justify-content-center me-2">
          <Button
            color="danger"
            onClick={() => editToggle()}
            disabled={
              userPermissions.R7.P !== "3" && userPermissions.R7.P !== "4"
            }
          >
            Edit Project Data
          </Button>
        </Col>
      </Row>

      <hr style={{ backgroundColor: "gray", height: "1px" }} />
      {editModal && (
        <EditProjectData
          editToggle={editToggle}
          project={project}
          editing={editing}
          setEditing={setEditing}
          setAuth={setAuth}
        />
      )}
      {/* {addNewticket && (
        <NewTicketModal
        newTicketToggle={addNewticketToggle}
        newTicketModal={addNewticket}
        ticketData={project}      
        type={"RD0"}  
        setAuth={setAuth} 
        StageID={10}   
        />
      )} */}
    </div>
  )
}

export default ProjectHeader
